'use client';

import * as React from 'react';
import styles from './Auth.module.css';

type PasswordFieldProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label: string;
};

export function PasswordField({ label, ...props }: PasswordFieldProps) {
  const [visible, setVisible] = React.useState(false);

  return (
    <label className={styles.field}>
      <span>{label}</span>
      <span className={styles.passwordWrap}>
        <input {...props} type={visible ? 'text' : 'password'} className={styles.input} />
        <button
          type="button"
          className={styles.eyeButton}
          aria-label={visible ? 'Скрыть пароль' : 'Показать пароль'}
          aria-pressed={visible}
          onClick={() => setVisible((value) => !value)}
        >
          <span
            className={`${styles.eyeIcon} ${visible ? '' : styles.eyeIconHidden}`}
            aria-hidden
          />
        </button>
      </span>
    </label>
  );
}
